import { render, staticRenderFns } from "./DicHouseFunds.vue?vue&type=template&id=5c9f63f2&scoped=true"
import script from "./DicHouseFunds.vue?vue&type=script&lang=js"
export * from "./DicHouseFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f63f2",
  null
  
)

export default component.exports